import InlineValueEditor from './InlineValueEditor';
import { InlineValueEditorContainer } from './styles';

export { InlineValueEditorContainer };
export default InlineValueEditor;
